module.exports = __webpack_public_path__ + "static/media/game-voice-marry.2f858d54.png";